export default "__VITE_ASSET__C0i4k1xw__"